import { useUnit } from 'effector-react'

import {
  $contestClients,
  $errorDemoContestRequest,
  demoContestClientListMounted,
  getContestClients,
} from './model'
import { DemoContestClientRequest } from './types'

export const useContestClientList = () => {
  const onChangeContestClientList = ({
    sorterField,
    searchText,
  }: DemoContestClientRequest) => {
    demoContestClientListMounted({
      sorterField,
      searchText,
    })
  }
  const loading = useUnit(getContestClients.pending)

  const contestClients = useUnit($contestClients)
  const errorDemoContestRequest = useUnit($errorDemoContestRequest)

  return {
    contestClients,
    loading,
    onChangeContestClientList,
    errorDemoContestRequest,
  }
}
